import TeamReportDataTable from "./TeamReportDataTable";

export default TeamReportDataTable;